<template>
    <div>
        <div class="hero fade-in-2s">
            <div class="hero-body kenburns-top"></div>
        </div>
        <div class="sdg-wheel-start fade-in-1s">
            <div class="columns">
                <div class="column is-5 is-offset-2 flex-direction-column">
                    <div class="sdg-title">
                        <icon class="hero-svg" name="logo"></icon>
                    </div>
                    <div class="sdg-subtitle">
                        <span>{{$t('landing.subtitle')}}</span>
                    </div>
                </div>
                <div class="column sdg-wheel-container">
                    <div class="landing-sdg-wheel-circle">
                        <wheel ref="landingWheel" :name="'landing'"></wheel>
                        <div class="scale-in-center-s1 start-button-wrapper flex-center">
                            <a @click="showLoginModal()" class="start-button">{{$t('landing.startButtonLabel')}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import wheel from './../shared/sdg-wheel/sdg-wheel'

export default {
  name: 'landing',
  components: {
    wheel
  },
  methods: {
    ...mapActions({
      setShowModal: 'setShowModal',
      setModalType: 'setModalType',
      setActivePageCode: 'setActivePageCode',
      setIconsPath: 'setIconsPath'
    }),
    showLoginModal () {
      this.setShowModal(true)
      this.setModalType('login-modal')
      // this.setActivePageCode('project')
    }
  },
  created () {
    this.setIconsPath()
  }
}
</script>
